export default {
  leastDrawn: 'Menos sorteados',
  mostDrawn: 'Más sorteados',
  leastPlayed: 'Menos jugados',
  mostPlayed: 'Más jugados',
  drawFrom: 'Sorteo de',
  h: 'h', // horas (abreviado)
  startingIn: 'Comienza en',
  waitingForDrawnFrom: 'Esperando sorteo de',
  displayingDrawFrom: 'Mostrando sorteo de',
  lotteryDraw: 'Sorteo de lotería',
  eventId: 'ID de evento',
  bettingShortcuts: 'Atajos de apuestas',
  draw: 'Sorteo',
  next5Events: 'Mostrando los próximos {value}',
  events: 'Eventos',
  schedule: 'Horario',
  next: 'Siguiente',
  event: 'Evento',
  later: 'Más tarde',
  statistics: 'Estadísticas',
  lastnRounds: 'Últimas {value} rondas',
  bettingOffer: 'Oferta de apuestas',
  notDisplayed: 'No mostrado',
  latestResults: 'Últimos resultados',
  drawnAt: 'Sorteado a las {value}',
  additionalBetting: 'Apuestas adicionales',
  drawSumEvenOdd: 'Suma del sorteo Par o Impar',
  drawSumTotal: 'Suma total del sorteo',
  drawSumRange: 'Rango de suma del sorteo',
  waitingForDrawNo: 'Esperando sorteo Nº{value}',
  nextDraw: 'Próximo sorteo',
  waitingForDraw: 'Esperando sorteo',
  drawCompleted: 'Sorteo completado',
  drawDisplayTemporarilyNotAvailable: 'Visualización del sorteo no disponible temporalmente',
  connectionError: '¡Error de conexión!',
  reconnecting: 'Reconectando...',
  number: 'Número',
  headerNumberDescriptionUp: 'Evento',
  headerNumberDescriptionDown: 'Número',
};
